import React from 'react';

import { l10n, lang } from '@ott/l10n';
import { number as cardNumberValidator } from '@ott/utility-card-validator';

const rules = {
  isRequired: (v) => v != null && v !== '' && v !== false && !Object.is(v, NaN),
};

const simpleCardValidation = function (ccNum) {
  return cardNumberValidator(ccNum).isValid;
};

const isRequired = {
  msg: l10n('required.required'),
  validate: rules.isRequired,
};

const isCreditCard = {
  msg: l10n('wrong.cardNumber'),
  validate: simpleCardValidation,
};
const isValidCVV = {
  msg: l10n('wrong.cardCvv'),
  validate: (v) => {
    v = v.toString();
    return v && v.length >= 3 && v.length <= 4;
  },
};

const Today = new Date();
const options = {
  minCardYear: Math.max(new Date().getYear() - 100, 15),
  minCardMonth: Today.getMonth() + 1,
  currentMonth: new Date().getMonth() + 1,
  currentYear: +new Date().getFullYear().toString().substr(2),
};

const isValidExpDateYY = {
  msg: l10n('wrong.cardYear'),
  validate: (year, values, props, opts) => {
    opts = opts || options;

    if (!year || year > opts.currentYear + 15) {
      return false;
    } else if (lang === 'ru') {
      return true;
    } else if (year < opts.currentYear) {
      return false;
    }

    return year >= opts.currentYear;
  },
};

const isValidExpDateMM = {
  msg: l10n('wrong.cardMonth'),
  validate: (month, values, props, opts) => {
    opts = opts || options;
    if (!month) {
      return false;
    }

    month = Number(month);
    if (month < 1 || month > 12) {
      return false;
    } else if (lang === 'ru') {
      return true;
    } else if (!values.expYear) {
      return true;
    } else {
      const year = Number(values.expYear);
      if (!isValidExpDateYY.validate(year, {}, {}, opts)) {
        return true;
      } else {
        return !(
          (year === opts.minCardYear && month < opts.minCardMonth) ||
          year < opts.minCardYear
        );
      }
    }
  },
};

const cardHolderReg = /^[A-Za-z\s\-]*$/;
const isValidCardHolder = {
  msg: l10n('wrong.cardHolder'),
  validate: (v) => {
    return cardHolderReg.test(v);
  },
};

export {
  isRequired,
  isCreditCard,
  isValidExpDateMM,
  isValidExpDateYY,
  isValidCardHolder,
  isValidCVV,
};
